export default __webpack_public_path__ + "static/media/ME.e5d33b18.svg";